export default __webpack_public_path__ + "static/Quickinstallation_08-ad7146e9bca51c7c7b214c7ab77d8655.webp";